import React from "react";
import {withRouter} from "react-router-dom";
import {Col, Row} from "react-bootstrap";
import {Button, Form, Input, Table, Spin} from "antd";
import HelperGeneral from "../../../helpers/HelperGeneral";
import moment from "moment";
import Api from "../../../services/Api";
import {setGlobalSpinner} from "../../../services/redux/actions/GeneralAction";
import UserInfo from "../../auth/UserInfo";


class CouponManagement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            basket_data: [],
            pagination: {
                current: 1,
                pageSize: 10,
            },
            transactionType: -1,
            ref: null,
            getBasketHeaderAll: {}
        };

        this.basket_list_column = [
            {
                title: 'İşlem Tarihi',
                dataIndex: 'date',
                sorter: false,
                width: 180,
                render: (name, record) => moment(record?.ProcessDate).format('DD.MM.YYYY HH:mm'),
            },
            {
                title: 'İşlem Türü',
                dataIndex: 'process_type',
                render: (name, record) => record?.ProcessType,
                width: 150,
            },
            {
                title: 'Açıklama',
                dataIndex: 'description',
                render: (name, record) => record?.Description,
                width: 300,
            },
            {
                title: 'Kupon Kodu',
                dataIndex: 'coupon_code',
                width: 150,
                render: (name, record) => record?.CouponCode,
            },
            {
                title: 'Dönüştürülen Puan',
                dataIndex: 'convert_point',
                width: 180,
                render: (name, record) => record?.ConvertPoint + ' Puan',
            },
            {
                title: 'Durum',
                dataIndex: 'process_status',
                width: 150,
                render: (text, record) => (
                    <span style={{color: this.ProcessStatusText(record?.ProcessStatus)}}>{record?.ProcessStatus}</span>
                )
            },
            {
                title: 'TL Karşılık',
                dataIndex: 'convert_cost',
                width: 150,
                render: (name, record) => record?.ConvertCost + ' TL',
            },
        ];

        this.getInputTotalScore = this.getInputTotalScore.bind(this);
        this.refInput = React.createRef();
        this.form = React.createRef();


    }

    componentDidMount() {
        //this.getBasketAll()
        //this.getBasketHeaderAll()
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.getTransactions({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            ...filters,
        });
    }

    getBasketAll() {
        this.setState({loading: true}, () => {
            Api.getBasketAll().then((e) => {
                this.setState({
                    loading: false,
                    basket_data: e.data?.result,
                }, () => {
                    setGlobalSpinner(false);
                });
            }).catch((e) => {
                setGlobalSpinner(false);
                HelperGeneral.alert(e);
                //HelperGeneral.pageChange(this, '/home');
            })
        });
    }

    ProcessStatusText(statusText) {
        let color = "";
        if (statusText === "Onaylandı") color = '#16bb00';
        else if (statusText === "Onay Bekliyor") color = '#ff7d00';
        else if (statusText === "İptal Edildi") color = '#ff0000';
        else if (statusText === "Kullanıldı") color = '#222222';
        return color;
    }


    scoreToLoad = (e) => {
        const {getBasketHeaderAll} = this.state;
        setGlobalSpinner(true);
        const user = UserInfo.info();
        const pharmacyId = user.Pharmacy.pharmacyId;
        const newScore = e.score_to_load;

        if (newScore > getBasketHeaderAll.UserPoint) {
            HelperGeneral.alert('Mevcut puanınızdan büyük olamaz');
            setGlobalSpinner(false);
            return false;
        }
        if (newScore <= 0) {
            HelperGeneral.alert('Girilen puan hatalıdır.');
            setGlobalSpinner(false);
            return false;
        }
        setGlobalSpinner(false);

        // Api.scoreToLoad(pharmacyId, newScore).then(response => {
        //     this.form?.current?.resetFields();
        //     setGlobalSpinner(false);
        //     this.getBasketAll();
        //     this.getBasketHeaderAll()
        // }).catch((e) => {
        //     setGlobalSpinner(false);
        //     HelperGeneral.alert(e);
        // });
    }

    getBasketHeaderAll() {
        const user = UserInfo.info();
        const userId = user.id;
        this.setState({
            loading: true
        }, () => {
            Api.getBasketHeaderAll(userId).then((e) => {
                this.setState({loading: false}, () => {
                    this.setState({
                        getBasketHeaderAll: e.data?.result,
                    });
                })
            }).catch((e) => {
                this.setState({loading: false}, () => {
                    HelperGeneral.alert(e);
                });
            })
        });
    }


    getInputTotalScore = () => {
        const {getBasketHeaderAll} = this.state;
        // this.form.current.setFieldsValue({
        //     score_to_load: getBasketHeaderAll?.UserPoint
        // });
        this.form.current.setFieldsValue({
            score_to_load: 5000
        });
    };


    render() {
        const user = UserInfo.info();
        const {basket_data, pagination, loading, transactionType, getBasketHeaderAll} = this.state;

        const couponSummary = (icon, name, number) => {
            let newIcon = require('../../../assets/images/svg/' + icon);
            return (
                <div className={'col-lg-3 col-12 '}>
                    <Spin spinning={loading}>
                        <div className={'box mb-0 h-100'}>
                            <div className={'row'}>
                                <div className={'col-2 d-flex align-items-center justify-content-start'}>
                                    <img alt={''}
                                         src={newIcon}
                                    />
                                </div>
                                <div className={'col-10'}>
                                    <div className={'row h-100'}>
                                        <div
                                            className={'col-12 d-flex align-items-end justify-content-end title'}>
                                            {name}
                                        </div>
                                        {/*<div className={'col-12 d-flex align-content-center justify-content-end price text-black'}>*/}
                                        {/*    {number}*/}
                                        {/*</div>*/}
                                        <div className={'col-12 d-flex align-content-center justify-content-end price text-black'}>
                                            5000
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Spin>
                </div>
            );
        };
        const suffix = () => {
            return (
                <span style={{color: '#f47918', cursor: 'pointer'}} onClick={this.getInputTotalScore}>
                 Tüm puanlar
                </span>
            )
        };
        return (
            <>
                <Row>
                    <Col>
                        <div className={"coupon-box"}>
                            <div className={'row'}>
                                {couponSummary('coupon-1.svg', 'Mevcut Puanınız', getBasketHeaderAll?.UserPoint)}
                                {couponSummary('coupon-2.svg', 'Mevcut Kuponlar', getBasketHeaderAll?.CurrentCouponPoint)}
                                {couponSummary('coupon-3.svg', 'Bekleyen Kuponlar', getBasketHeaderAll?.PendingCouponPoint)}
                                {couponSummary('coupon-4.svg', 'Kullanılan Kuponlar', getBasketHeaderAll?.UsedCouponPoint)}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className={'product-history m-0 mt-5 coupon-box'}>
                            <Form
                                ref={this.form}
                                layout={'vertical'}
                                onFinish={(e) => this.scoreToLoad(e)}
                            >
                                <div className={'row'}>
                                    <div
                                        className={'col-lg-6 col-12 text-lg-start text-center'}>
                                        <h3 className={'text-lg-start text-center'}>Puan Yükle</h3>
                                        <p className={'text-lg-start text-center'}><br/></p>

                                        <Form.Item
                                            name="score_to_load"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Puanınızı girmeniz gerekmektedir.',
                                                }
                                            ]}

                                        >
                                            <Input type={'number'} suffix={suffix()}/>
                                        </Form.Item>
                                    </div>
                                    <div className={'col-lg-6 col-12 '}>
                                        <div className={'row h-100'}>
                                            <div className={'col-lg-4 col-12 '}>
                                                <div className={'row h-100 position-relative'}>
                                                    <sup>TL</sup>
                                                    {/*<div className={'col-12 d-flex align-items-end justify-content-center price text-black'}>*/}
                                                    {/*    {getBasketHeaderAll?.MaximumAmount}*/}
                                                    {/*</div>*/}
                                                    <div className={'col-12 d-flex align-items-end justify-content-center price text-black'}>
                                                       5000
                                                    </div>

                                                    <div
                                                        className={'col-12 d-flex align-items-end justify-content-start title mb-lg-0 mb-3 '}>
                                                        <Form.Item className={'w-100'}>
                                                            <Button
                                                                htmlType={'submit'}
                                                                className={'coupon-button  w-100'}>Puan Yükle</Button>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className={'col-lg-8 col-12 d-flex align-content-center justify-content-center '}>
                                                <div
                                                    className={'box right-box w-100 h-100 m-0 p-0'}>
                                                    <p>Bilgilendirme </p>
                                                    <p>Puan Yükle işlemini gerçekleştirdikten
                                                        sonra talep etmiş olduğunuz dönüşüm
                                                        işlemi gerçekleştirilecek olup onay
                                                        aşamasından sonra listede Durum
                                                        kısmından Kupon Kodu’nu takip
                                                        edebilirsiniz.</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className={'product-history m-0 mt-4'}>
                            <h3>Kuponlarım ve Kullanım Geçmişi</h3>
                            <Table
                                columns={this.basket_list_column}
                                rowKey={record => record.ProcessDate}
                                dataSource={basket_data}
                                loading={loading}
                                onChange={this.handleTableChange}
                            />
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
}

export default withRouter(CouponManagement);
